import { busService } from "../bus";
import { MulticastDelegate, getQueryParameter, MulticastDelegate1 } from "flavr-common";
import { ChangeLocalUserInfoMessage } from "../../messages/session/SessionMessages";
import { UNDEFINED_USER } from "../users";
import { PeerAddedMessage } from "../../messages/session/PeerMessages";
class UsersService {
    constructor() {
        this.users = new Map();
        this.localUserChangedDelegate = new MulticastDelegate();
        this.onUserAddedDelegate = new MulticastDelegate1();
        this.onUserRemovedDelegate = new MulticastDelegate();
        this.localUser = UNDEFINED_USER;
        this.avatarUIds = new Map();
        this.uidToClientId = new Map();
        this.pendingAvatarUids = new Map();
        const locationHref = window.location.href;
        const newUsername = getQueryParameter(locationHref, "username");
        if (newUsername) {
            this.customUsername = newUsername;
        }
        busService.connection("UserService").subscribeByType(PeerAddedMessage, (_msg) => {
            var _a, _b;
            const username = (_a = localStorage.getItem("username")) !== null && _a !== void 0 ? _a : "Guest";
            const storedAvatar = JSON.parse((_b = localStorage.getItem("avatar")) !== null && _b !== void 0 ? _b : "null");
            if (storedAvatar)
                busService.connection("UserService").send(new ChangeLocalUserInfoMessage({
                    customUsername: username,
                    avatar: storedAvatar
                }));
        });
    }
    getNumberOfUsers() {
        return this.users.size;
    }
    getCustomUsername() {
        return this.customUsername;
    }
    setCustomUsername(username) {
        this.customUsername = username;
    }
    addUser(user) {
        const isNewUser = !this.users.has(user.clientId);
        this.users.set(user.clientId, user);
        this.onUserAddedDelegate.invoke(user);
        return isNewUser;
    }
    removeUser(clientId) {
        const removed = this.users.delete(clientId);
        const uid = this.avatarUIds.get(clientId);
        if (uid !== undefined) {
            this.uidToClientId.delete(uid);
            this.avatarUIds.delete(clientId);
        }
        if (removed) {
            this.onUserRemovedDelegate.invoke();
        }
    }
    getUserByClientId(clientId) {
        return this.users.get(clientId);
    }
    hasUserByClientId(clientId) {
        return this.users.has(clientId);
    }
    setLocalUser(user) {
        var _a;
        this.addUser(user);
        this.localUser = user;
        this.localUserChangedDelegate.invoke();
        if (this.localUser.guest) {
            const guestUser = this.getGuestInfo();
            this.setGuestUserInfo(guestUser.username, guestUser.avatar);
        }
        const identity = (_a = user.identity) !== null && _a !== void 0 ? _a : { username: "unknown", firstname: "unknown", lastname: "unknown" };
        console.debug(`[multiplayer] Set local user ${user.clientId}`, identity);
    }
    getLocalUser() {
        return this.localUser;
    }
    setUserAvatarUid(clientId, uid) {
        const existingUid = this.avatarUIds.get(clientId);
        if (existingUid !== undefined) {
            this.uidToClientId.delete(existingUid);
        }
        this.avatarUIds.set(clientId, uid);
        this.uidToClientId.set(uid, clientId);
        const pendings = this.pendingAvatarUids.get(uid);
        if (pendings) {
            for (const data of pendings) {
                self.clearTimeout(data.timeoutHandle);
                data.resolve(clientId);
            }
            this.pendingAvatarUids.delete(uid);
        }
    }
    getClientIdByAvatarUid(uid) {
        return this.uidToClientId.get(uid);
    }
    getDisplayName(clientId) {
        const user = this.getUserByClientId(clientId);
        if (!user) {
            return "Unknown";
        }
        if (user.customUsername) {
            return user.customUsername;
        }
        if (user.guest) {
            return "Guest";
        }
        if (user.identity) {
            return `${user.identity.firstname} ${user.identity.lastname}`;
        }
        return "Guest";
    }
    getLocalDisplayName() {
        return this.getDisplayName(this.localUser.clientId);
    }
    checkAccessoiresChanged(a, b) {
        if (a === undefined && b === undefined)
            return false;
        if (a === undefined || b === undefined)
            return true;
        if (a.length !== b.length)
            return true;
        for (const [index, aElement] of a.entries()) {
            const bElement = b[index];
            if (aElement.id !== bElement.id)
                return true;
            if (aElement.color !== bElement.id)
                return true;
        }
        return false;
    }
    setGuestUserInfo(username, avatar) {
        const oldDisplayName = usersService.getDisplayName(this.localUser.clientId);
        const displayNameChanged = username !== oldDisplayName;
        const avatarChanged = avatar.baseColor !== this.localUser.avatar.baseColor ||
            avatar.style !== this.localUser.avatar.style ||
            this.checkAccessoiresChanged(avatar.accessoires, this.localUser.avatar.accessoires);
        if (!displayNameChanged && !avatarChanged) {
            return false;
        }
        this.localUser.customUsername = username;
        localStorage.setItem("username", username);
        busService.connection("UserService").send(new ChangeLocalUserInfoMessage({
            customUsername: username,
            avatar: avatar
        }));
    }
    getGuestInfo() {
        var _a;
        let username = this.getLocalDisplayName();
        const avatar = Object.assign({}, this.localUser.avatar);
        username = (_a = localStorage.getItem("username")) !== null && _a !== void 0 ? _a : username;
        return {
            username,
            avatar
        };
    }
}
export const usersService = new UsersService();
